import { useMemo } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import {
  setLimit,
  setPage,
  setTotal,
  setColumnVisibility,
  setProviderIgnoredRequestsTableFilters,
  setClearProviderIgnoredRequestsTableFilters,
} from '@Modal/reducers/providerIgnoredRequests/providerIgnoredRequestsTableSlice';

// Types
import { StoreInterface } from 'src/app/types';
import { FilterItemType } from '@Modal/reducers/types';

export const useProviderIgnoredRequestsTable = () => {
  const dispatch = useDispatch();

  const {
    page,
    limit,
    total,
    selectedFilters,
    columnVisibility,
    columnVisibilityOptions,
    providerIgnoredRequestsTableFilters,
  } = useSelector((state: StoreInterface) => state?.providerIgnoredRequestsTable);

  const providerIgnoredRequestsListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...providerIgnoredRequestsListFilters, ...column];
    if (providerIgnoredRequestsListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = providerIgnoredRequestsListFilters.filter(
        (col) => col !== column[0]
      );
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  const handleFilterSelect = (filter: FilterItemType) => {
    dispatch(setProviderIgnoredRequestsTableFilters(filter));
  };

  const handleClearProviderIgnoredRequestsTableFilters = () => {
    dispatch(setClearProviderIgnoredRequestsTableFilters());
  };

  return {
    // State
    page,
    total,
    limit,
    selectedFilters,
    columnVisibility,
    visiblityCustomizable,
    columnVisibilityOptions,
    providerIgnoredRequestsListFilters,
    providerIgnoredRequestsTableFilters,
    // Actions
    setLimit,
    setPage,
    setTotal,
    setProviderIgnoredRequestsTableFilters,
    setClearProviderIgnoredRequestsTableFilters,
    // Handlers
    handleFilterSelect,
    handleApplyColumnVisibility,
    handleClearProviderIgnoredRequestsTableFilters,
  };
};
